import AllProjects from "../../../../src/components/projects/all-projects";
import * as React from 'react';
export default {
  AllProjects,
  React
};